/**
 * Slash Command Service
 * Frontend client for the slash-command list + execute endpoints.
 */

import { apiClient } from './api.client';

export interface SlashCommand {
  name: string;
  description: string;
  usage: string;
  requiresAdmin: boolean;
}

export interface CommandResult {
  success: boolean;
  message?: string;
  modifiedContent?: string;
  ephemeral?: boolean;
  action?: 'replace' | 'send' | 'nothing';
}

/**
 * List available slash commands for autocomplete.
 * Backend filters admin-only commands based on the caller's role.
 */
export async function listSlashCommands(): Promise<SlashCommand[]> {
  const response = await apiClient.get<{ commands: SlashCommand[] }>('/slash-commands');
  return response.data.commands;
}

/**
 * Execute a slash command.
 * The endpoint responds with a CommandResult (raw body, not wrapped in {status,data}).
 */
export async function executeSlashCommand(
  content: string,
  scope: { channelId?: string; dmThreadId?: string }
): Promise<CommandResult> {
  const response = await apiClient.post<CommandResult>('/slash-commands/execute', {
    content,
    channelId: scope.channelId,
    dmThreadId: scope.dmThreadId,
  });
  return response.data;
}
